export const propertyTypes = ['Sale', 'Rent'];
export const propertyFinalizingList = ['Not Finalized', 'Normal Finalizing', 'Super Finalizing', 'High Class Finalizing'];
export const rentAmountPerList = [{
    id: 1,
    name: 'Per Night',
},
    {
        id: 2,
        name: 'Per Week',
    },
    {
        id: 3,
        name: 'Per Month',
    },
    {
        id: 4,
        name: 'Per Year',
    }];
